"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var colors = _interopRequireWildcard(require("@cimpress/react-components/lib/colors"));

var _emotion = require("emotion");

var _throttle = _interopRequireDefault(require("lodash/throttle"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var cellStates = _interopRequireWildcard(require("../cellStates"));

var shapes = _interopRequireWildcard(require("../shapes"));

var _DragHandle = _interopRequireDefault(require("./DragHandle"));

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  background-color: #d3d9df;\n  box-shadow: inset 0 -2px #75b2d8;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  cursor: col-resize;\n  height: 100%;\n  position: absolute;\n  right: -5px;\n  top: 0;\n  width: 10px;\n  z-index: 1;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n  border-right: 1px solid ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  border-left: 1px solid ", ";\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  height: calc(100% - 4px);\n  justify-content: center;\n  margin: 2px 0;\n  padding: 0 11px;\n  position: relative;\n  user-select: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var cellStyle = (0, _emotion.css)(_templateObject(), colors.white);
var cellLastStyle = (0, _emotion.css)(_templateObject2(), cellStyle, colors.white);
var dragStyle = (0, _emotion.css)(_templateObject3());
var selectedStyle = (0, _emotion.css)(_templateObject4());
var titleStyle = (0, _emotion.css)(_templateObject5());

function isLeftOrRight(buttons) {
  /* eslint-disable-next-line no-bitwise */
  return buttons & 0x01 || buttons & 0x02;
}

var ColumnHeaderCell =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(ColumnHeaderCell, _PureComponent);

  function ColumnHeaderCell() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ColumnHeaderCell);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ColumnHeaderCell)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dragStart", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "widthStart", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onHandleDragEnd", function (pageX) {
      var columnIndex = _this.props.columnIndex;

      _this.onTriggerResize(columnIndex, pageX);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onHandleDragMove", function (pageX) {
      var columnIndex = _this.props.columnIndex;

      _this.onTriggerResize(columnIndex, pageX);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onHandleDragStart", function (pageX) {
      var width = _this.props.width;
      _this.dragStart = pageX;
      _this.widthStart = width;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onMouseDown", function (event) {
      var _this$props = _this.props,
          columnIndex = _this$props.columnIndex,
          onDragStart = _this$props.onDragStart;

      if (isLeftOrRight(event.buttons)) {
        onDragStart(columnIndex);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onMouseOver", function (event) {
      var _this$props2 = _this.props,
          columnIndex = _this$props2.columnIndex,
          onDragMove = _this$props2.onDragMove;

      if (isLeftOrRight(event.buttons)) {
        onDragMove(columnIndex);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onTriggerResize", (0, _throttle.default)(function (columnIndex, dragCurrent) {
      var onResize = _this.props.onResize;
      var dragAmount = dragCurrent - _this.dragStart;
      var width = Math.max(40, _this.widthStart + dragAmount);
      onResize && onResize(columnIndex, width);
    }, 15));
    return _this;
  }

  (0, _createClass2.default)(ColumnHeaderCell, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          columns = _this$props3.columns,
          columnIndex = _this$props3.columnIndex,
          mode = _this$props3.mode,
          style = _this$props3.style;
      var column = columns[columnIndex];
      var isLastColumn = columnIndex === columns.length - 1;
      var isSelected = mode !== cellStates.inactive;
      /* eslint-disable jsx-a11y/no-static-element-interactions */

      /* eslint-disable jsx-a11y/mouse-events-have-key-events */

      return _react.default.createElement("div", {
        className: isSelected ? selectedStyle : null,
        style: style,
        onMouseDown: this.onMouseDown,
        onMouseOver: this.onMouseOver
      }, _react.default.createElement("div", {
        className: isLastColumn ? cellLastStyle : cellStyle
      }, _react.default.createElement("div", {
        className: titleStyle
      }, column)), _react.default.createElement(_DragHandle.default, {
        className: dragStyle,
        onDragEnd: this.onHandleDragEnd,
        onDragMove: this.onHandleDragMove,
        onDragStart: this.onHandleDragStart
      }));
      /* eslint-enable jsx-a11y/no-static-element-interactions */

      /* eslint-enable jsx-a11y/mouse-events-have-key-events */
    }
  }]);
  return ColumnHeaderCell;
}(_react.PureComponent);

exports.default = ColumnHeaderCell;
(0, _defineProperty2.default)(ColumnHeaderCell, "propTypes", {
  columns: _propTypes.default.arrayOf(shapes.column).isRequired,
  columnIndex: _propTypes.default.number.isRequired,
  mode: shapes.cellMode.isRequired,
  style: _propTypes.default.objectOf(_propTypes.default.any),
  width: _propTypes.default.number.isRequired,
  onDragMove: _propTypes.default.func.isRequired,
  onDragStart: _propTypes.default.func.isRequired,
  onResize: _propTypes.default.func
});